import { render, staticRenderFns } from "./clipr_purchases.vue?vue&type=template&id=54ce066b&scoped=true"
import script from "./clipr_purchases.vue?vue&type=script&lang=js"
export * from "./clipr_purchases.vue?vue&type=script&lang=js"
import style0 from "./clipr_purchases.vue?vue&type=style&index=0&id=54ce066b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce066b",
  null
  
)

export default component.exports